export default "__VITE_ASSET__Bd3ZBy34__"